import type { RfqType } from "@convex/constants/types";

export const RFQ_TYPE_LABELS: Record<RfqType, string> = {
  buy: "Buy",
  sell: "Sell",
  recycle: "Recycle",
};
